module.exports = require('./helpers/bundle-url').getBundleURL('kAx7u') + "logo.c51670a8.svg";